import React from 'react';
import { AIcon } from '../../atoms/AIcon/index';
import * as Styled from './MButtonOverlay.styles';
import type { MButtonOverlayProps } from './MButtonOverlay.types';

const COMPONENT_NAME = 'm-web-ui-kit-MButtonOverlay';
const TEST_ID = 'web-ui-kit-MButtonOverlay';

export const MButtonOverlay: React.FC<MButtonOverlayProps> = ({
  imageOverlay = false,
  iconOnly = false,
  text,
  aIcon,
  className,
  ...rest
}) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
      $imageOverlay={imageOverlay}
      $iconOnly={iconOnly}
      {...rest}
    >
      <Styled.Content>
        {aIcon && <AIcon {...aIcon} />}
        {!iconOnly && text && <Styled.Text>{text}</Styled.Text>}
      </Styled.Content>
    </Styled.Wrapper>
  );
};

export { TEST_ID as M_BUTTON_OVERLAY_TEST_ID };
export type { MButtonOverlayProps };
